import Toaster from 'toastr';
import Messages from '../configurations/messages'; 
import * as types from './actionTypes';
import UserApi from '../api/UserApi';
// import { permissionsObject } from '../configurations/permissions';
// const permissionsObj = permissionsObject;


export function loadUserPermissionsSuccess(permissions) {
    return { type: types.LOAD_USER_PERMISSIONS_SUCCESS, permissions };
}

// const permissionsObj = permissionsObject;

export function loadUserPermissions() {
    return function (dispatch) {
        
        return UserApi.getUserPermissions().then(response => {
            let permissions = response.data.map(auth => { return auth.authority; });
            dispatch(loadUserPermissionsSuccess(permissions));
        }).catch(error => {
            //  let permissions = Object.values(permissionsObj);
            // dispatch(loadUserPermissionsSuccess(permissions));

            Toaster.error(Messages.LOAD_PERMISSIONS_ERROR);
            console.log(error);
            dispatch(loadUserPermissionsSuccess([]));
        });
    };
}



// WEBPACK FOOTER //
// ./src/actions/permissionsAction.js